<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url" :head="head"></Breadcrumbs>
        <trashed-message v-if="faq.deleted_at" class="mb-6" @restore="restore"> This Faq has been deleted.
        </trashed-message>
        <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Title" required="true" placeholder="i.e How to use this website?" />
                    <select-input v-model="form.cat_id" :error="form.errors.cat_id" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Category" required="true">
                        <option :value=null>Select Category</option>
                        <option v-for="faqItem in faqCat" :key="faqItem.id" :value='faqItem.id'>{{ faqItem.title }}
                        </option>
                    </select-input>
                    <select-input v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Category" required="true">
                        <option :value=null>Select Content Type</option>
                        <option value='content'>Content</option>
                        <option value='image'>Image</option>
                        <option value='pdf'>Pdf</option>
                        <option value='video'>Video</option>
                    </select-input>
                    <template v-if="form.type == 'image' || form.type == 'pdf'">
                        <div class="mt-1 flex pb-8 pr-6 w-full lg:w-1/1 items-center">
                            <div
                                class="mt-1 flex flex-wrap justify-center rounded-md border-2 border-dashed border-gray-300 dark:border-black dark:bg-white dark:text-black px-6 pt-5 pb-6">
                                <div class="space-y-1 text-center">
                                    <PhotoBlock :getPhoto="form.attachment" @SetPhoto="set_photo" />
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="form.type == 'video'">
                        <div class="pb-8 pr-6 w-full lg:w-1/1">
                            <text-input v-model="form.embed_url" :error="form.errors.embed_url"
                                class="pb-8 pr-6 w-full lg:w-1/1" label="Embed Code" required="true"
                                placeholder="i.e https://www.youtube.com/watch?v=P-I4Bay5SXo" />
                        </div>
                    </template>
                    <template v-else-if="form.type == 'content'">
                        <div class="pb-8 pr-6 w-full lg:w-1/1">
                            <label class="form-label" for="description">Description<span
                                    class="custom-error">*</span></label>
                            <vue-editor v-model="form.description" />
                        </div>
                    </template>
                    <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status"
                        class="pb-8 pr-6 w-full lg:w-1/1"></status-toogle-button>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <button v-if="!faq.deleted_at && permission.edit > 0" class="text-red-600 hover:underline"
                        tabindex="-1" type="button" @click="destroy"><delete-icon></delete-icon></button>
                    <Button v-if="permission.edit > 0" :type="type" :name="head" :url="createUrl"
                        :loading="form.processing"></Button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from '@/Shared/Breadcrumbs'
import Button from '@/Shared/Button'
import DeleteIcon from '@/Shared/DeleteIcon'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, toRefs, inject } from 'vue'
import { Quill, VueEditor } from "vue3-editor"
import PhotoBlock from './Photo';
export default {
    components: {
        Head,
        Icon,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
        StatusToogleButton,
        Breadcrumbs,
        DeleteIcon,
        Button,
        TextareaInput,
        Quill,
        VueEditor,
        PhotoBlock
    },
    layout: Layout,
    props: {
        faq: Object,
        faqCat: Array,
        permission: Object,
    },
    remember: 'form',
    setup(props) {
        const { faq, permission, faqCat } = toRefs(props)
        const type = ref('edit')
        const title = ref(faq.value.title)
        const head = ref('FAQ')
        const url = ref('/backend/faqs')
        const swal = inject('$swal')
        const createUrl = ref('')
        const elm = ref(this)
        const form = useForm({
            title: faq.value.title,
            description: faq.value.description,
            status: faq.value.status,
            cat_id: faq.value.cat_id,
            type: faq.value.type,
            embed_url: faq.value.embed_url,
            attachment: faq.value.attachment,
        })
        const update = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to proceed with this action",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.put(`${url.value}/${faq.value.id}`)
                    title.value = form.title
                    swal.fire(
                        'Updated!',
                        'Your infomation has been Updated.',
                        'success'
                    )
                }
            });
        }

        const destroy = () => {
            swal({
                title: 'Are you sure?',
                text: "Do you really want to delete this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    form.delete(`${url.value}/${faq.value.id}`)
                    swal.fire(
                        'Deleted!',
                        'Your infomation has been deleted.',
                        'success'
                    )
                }
            });
        }
        const restore = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to restore this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Resore it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    form.put(`${url.value}/${faq.value.id}/restore`)
                    swal.fire(
                        'Restored!',
                        'Your infomation has been Restored.',
                        'success'
                    )
                }
            });
        }
        const statusCheck = () => {
            if (faq.value.status == 1) {
                form.status = true;
                return true;
            } else {
                form.status = false;
                return false;
            }
        }
        const set_photo = (val) => {
            form.attachment = val
        }
        return {
            form,
            faq,
            type,
            title,
            head,
            url,
            createUrl,
            faqCat,
            update,
            destroy,
            restore,
            statusCheck,
            swal,
            permission,
            set_photo
        }
    },
    created: function () {
        this.statusCheck();
    }

}
</script>
